import React, { useRef, useEffect } from 'react';
import { ManualABNTContent } from './ManualABNTContent';
import type { ManualABNTData } from '@/data/manuals/fleetone-abnt-content';
import './ManualABNTPrint.css';

interface ManualABNTInlineProps {
  manualData: ManualABNTData;
  onScrollSpy?: (section: string) => void;
}

export const ManualABNTInline: React.FC<ManualABNTInlineProps> = ({
  manualData,
  onScrollSpy
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const handleScrollSpy = (section: string) => {
    onScrollSpy?.(section);
  };

  useEffect(() => {
    // Deep linking
    const params = new URLSearchParams(window.location.search);
    const section = params.get('section');
    
    if (section) {
      setTimeout(() => {
        const element = document.getElementById(`section-${section}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="flex flex-col h-full min-h-0 manual-wrapper">
      {/* Cabeçalho Premium */}
      <header className="manual__header">
        <span className="badge-gradient">
          {manualData.preTextual.cover.badge}
        </span>
        <h1 className="manual-title">
          {manualData.metadata.title}
        </h1>
        <p className="manual-subtitle">
          {manualData.metadata.subtitle}
        </p>
        <div className="meta">
          <span className="meta__pill">
            Versão <strong>{manualData.metadata.version}</strong>
          </span>
          <span className="meta__pill">
            Ano <strong>{manualData.metadata.year}</strong>
          </span>
          <span className="meta__pill">
            Formato <strong>{manualData.metadata.format}</strong>
          </span>
        </div>
      </header>

      {/* Conteúdo com scroll independente */}
      <div 
        ref={contentRef}
        id="manual-abnt-inline-container"
        className="flex-1 min-h-0 overflow-y-auto px-6 py-6 custom-scrollbar"
      >
        {/* Conteúdo ABNT com sections em cards */}
        <ManualABNTContent
          sections={manualData.body.sections}
          onScrollSpy={handleScrollSpy}
          searchQuery=""
          containerRef={contentRef}
        />
      </div>
    </div>
  );
};
